import React from 'react';
import ResetPassword from '../../@jumbo/components/Common/authComponents/ResetPassword';

const ResetPasswordRoute = () => <ResetPassword variant="standard" wrapperVariant="bgColor" />;

export default ResetPasswordRoute;
